// extracted by css-extract-rspack-plugin
export default {"headerContainer":"_eae4d52","bottomModule":"_3a862c9f","recentlyViewed":"_e5191758"};